/**************************************************
 * Nombre:       F_RegistrarCompra
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {React} from 'react';
import {Grid} from "@mui/material";
import {FormBase} from "../../Modulo_Formularios/ComponentesBase/C_Forms";
import {Building3, Cake, Flag, Google, Message, Mobile, Personalcard, User} from "iconsax-react";


const F_ParteNostros = ({...props}) => {

    return (
        <FormBase {...props} >

            <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="flex-start"
                spacing={2}
            >
                <Grid item lg={6} sm={12} xs={12}>
                    <FormBase.InputIcon dato={"nombre"} label={"Nombre y Apellido"} Icono={User}/>
                </Grid>

                <Grid item lg={6} sm={12} xs={6}>
                    <FormBase.InputIcon dato={"celular"} label={"Celular de Contacto"} type={"number"}
                                        Icono={Mobile}/>
                </Grid>

                {/*} <Grid item lg={6} sm={12} xs={6}>
                    <FormBase.InputIcon dato={"tipo"} label={"Típo de Rubro"} Icono={Flag}/>
                </Grid>*/}

                <Grid item lg={12} sm={12} xs={12}>
                    <FormBase.InputIcon dato={"correo"} label={"Correo"} Icono={Google}/>
                </Grid>

                <Grid item lg={12} sm={12} xs={12}>
                    <FormBase.InputIcon dato={"mensaje"} label={"Mensaje"} Icono={Message} lineas={8}/>
                </Grid>

            </Grid>

        </FormBase>
    )
}

export default F_ParteNostros;